import * as React from 'react';
import {Shop} from 'interfaces';

import {
  ShopAskingPrice,
  ShopHeader,
  ShopMetrics,
  ShopScreenshot,
} from './components';

export interface Props {
  shop: Shop;
}

const style = {
  inner: 'layout-fill-space shop-tile',
  tile: 'grid__item grid__item--tablet-up-third grid__item--desktop-up-quarter grid__item--wide-up-quarter gutter-bottom category-tile-grid-item layout-flex',
};

class ShopTile extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {shop} = this.props;
    const {featured} = shop;

    return (
      <div className={style.tile}>
        <div
          className={style.inner}
          aria-label={featured ? 'Featured' : 'For sale'}
        >
          <ShopScreenshot
            shop={this.props.shop}
          />
          <ShopHeader
            shop={this.props.shop}
          />
          <ShopMetrics
            shop={this.props.shop}
          />
          <ShopAskingPrice
            shop={this.props.shop}
          />
        </div>
      </div>
    );
  }
}

export default ShopTile;
